exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-7d6cb96e] .md-table-head-label {\r\n    color: #4caf50 !important;\n}\r\n", ""]);

// exports
